import React from 'react';
import { connect } from 'react-redux';
import Tag from '~/components/Tag';
import Task from '~/components/Task';
import {
  taskDone,
  taskSkip,
} from '~/actions/tasks';
import { Button, IconButton } from 'react-toolbox/lib/button';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  getStatus() {
    const { task, parents } = this.props;
    if (task.resolution) {
      return task.resolution.type;
    }
    if (parents.find(p => p.resolution === undefined)) {
      return 'blocked';
    }
    return 'pending';
  }

  render() {
    const { task } = this.props;
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div>
            <Task id={this.props.data.id} className={styleLocal.task} onClick={undefined} onEdit={() => this.context.dialogPush('taskNew', { id: task.id })} />
            {task && <div>
              {this.getStatus() === 'pending' && <div>
                <Button
                  label="Done"
                  icon="done"
                  className={styleLocal.green}
                  onClick={e => {
                    e.stopPropagation();
                    taskDone(this.props.dispatch, this.context.apiClient, task.id, '');
                  }}
                />
                <Button
                  label="Skip"
                  icon="fast_forward"
                  className={styleLocal.yellow}
                  onClick={e => {
                    e.stopPropagation();
                    taskSkip(this.props.dispatch, this.context.apiClient, task.id, '');
                  }}
                />
              </div>}
              {task.resolution && <div className={styleLocal.resolution}>
                <div className={styleLocal.date}>
                  {new Date(task.resolution.date).toLocaleString()}<br />
                  <Tag type="user" id={task.resolution.userId} className={styleLocal.user} />
                </div>
                <div className={styleLocal.type}>Task resolved</div>
                <div className={styleLocal.comment}>{task.resolution.comment || 'No comment'}</div>
              </div>}
              {task.removed && <div className={styleLocal.removed}>REMOVED</div>}
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const task = state.getIn(['tasks', 'items', props.data.id]);
  if (!task) { return { task: null, parents: [] }; }
  const parents = Object.values(state.getIn(['tasks', 'items']).toJS()).filter(t => task.get('parentTaskId', []).includes(t.id));
  return { task: task.toJS(), parents };
};

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/Task/index.js